var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable react/jsx-props-no-spreading */
import React, { createRef, useEffect, useState } from 'react';
import dateFormat from 'dateformat';
import { useIntl, defineMessages } from 'react-intl';
import Input from '../BasicInput';
var daysPerMonth = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var messages = defineMessages({
    correctTheDate: {
        defaultMessage: 'Please correct the date (format: DD.MM.YYYY)',
        id: 'input.date.error',
    },
});
var DateInput = function (_a) {
    var minDate = _a.minDate, maxDate = _a.maxDate, date = _a.date, initialValue = _a.value, defaultValue = _a.defaultValue, error = _a.error, onChange = _a.onChange, onDateChange = _a.onDateChange, props = __rest(_a, ["minDate", "maxDate", "date", "value", "defaultValue", "error", "onChange", "onDateChange"]);
    var initialDate = date
        ? date.toISOString().substr(0, 10)
        : (defaultValue || initialValue);
    var _b = useState({
        currentDate: initialDate != null && initialDate !== '' ? new Date(initialDate) : undefined,
        inputValue: initialDate,
        nativeDateInput: true,
        hadContent: initialDate != null && initialDate !== '',
        displayedError: error,
    }), state = _b[0], setState = _b[1];
    var inputRef = createRef();
    var intl = useIntl();
    var determineErrorMessage = function () {
        // previously this was debounced, but if there is an "outer error message",
        // debouncing here will cause changing between the "outer" and the "inner" error message
        // unless we make everything even more complicated. so no debouncing anymore
        var mayShowError = state.hadContent;
        var errorMessage = mayShowError && state.currentDate == null
            ? intl.formatMessage(messages.correctTheDate)
            : error;
        if (errorMessage != state.displayedError) {
            setState(__assign(__assign({}, state), { displayedError: errorMessage }));
        }
    };
    // in non native date mode we have to process the input ourself
    var onChangeInternal = function (e) {
        var value = e.target.value;
        if (!state.nativeDateInput && value) {
            value = value.replace(/^(\d{1,2})[.,](\d{1,2})[.,](\d{4})$/, '$3-$2-$1');
        }
        var data = /(\d+)-(\d+)-(\d+)/.exec(value);
        var currentDate;
        if (data) {
            var year = parseInt(data[1], 10);
            var month = parseInt(data[2], 10);
            var day = parseInt(data[3], 10);
            if (year > 1800 &&
                year < 2200 &&
                month >= 1 &&
                month <= 12 &&
                day >= 1 &&
                (day <= daysPerMonth[month] ||
                    (day === 29 && year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0)))) {
                try {
                    currentDate = new Date(year, month - 1, day, 12);
                }
                catch (_e) {
                    currentDate = undefined;
                }
            }
        }
        if (currentDate) {
            if ((minDate &&
                currentDate.toISOString().substr(0, 10) < minDate.toISOString().substr(0, 10)) ||
                (maxDate && currentDate.toISOString().substr(0, 10) > maxDate.toISOString().substr(0, 10))) {
                currentDate = undefined;
            }
        }
        if (onDateChange) {
            if (currentDate) {
                var callbackDate = new Date(currentDate.toISOString().substr(0, 10));
                onDateChange(callbackDate);
            }
            else {
                onDateChange(undefined);
            }
        }
        setState(__assign(__assign({}, state), { inputValue: e.target.value, currentDate: currentDate, hadContent: state.hadContent || e.target.value !== '' }));
        determineErrorMessage();
    };
    // after rendering, we need to test for non native date input element
    useEffect(function () {
        if (inputRef.current) {
            var isNativeDate = inputRef.current.type === 'date';
            var newValue = state.inputValue;
            if (!isNativeDate) {
                var value = inputRef.current.value;
                if (value != null && value !== '') {
                    newValue = dateFormat(new Date(value), 'dd.mm.yyyy');
                    inputRef.current.value = newValue;
                }
            }
            setState(__assign(__assign({}, state), { nativeDateInput: isNativeDate, inputValue: newValue }));
            determineErrorMessage();
        }
    }, []);
    determineErrorMessage();
    return (React.createElement(React.Fragment, null,
        React.createElement(Input, __assign({ type: "date", onChange: function (e) {
                onChangeInternal(e);
                if (onChange) {
                    onChange(e);
                }
            }, inputRef: inputRef, "data-date": state.currentDate && state.currentDate.toISOString().substr(0, 10), defaultValue: state.inputValue, error: state.displayedError, max: maxDate ? maxDate.toISOString().substr(0, 10) : undefined, min: minDate ? minDate.toISOString().substr(0, 10) : undefined, validationRules: [] }, props))));
};
export default DateInput;
export var TouchDetectingDateInput = function (_a) {
    var props = __rest(_a, []);
    // a simple check should suffice - if our touch detection is wrong the input is still usable
    var isTouchDevice = document && document.documentElement ? 'ontouchstart' in document.documentElement : false;
    if (isTouchDevice) {
        return React.createElement(DateInput, __assign({ type: "text" }, props));
    }
    return React.createElement(DateInput, __assign({ type: "date" }, props));
};
//# sourceMappingURL=index.js.map